<div class="card">
  <div class="icon-class">
    <img src="{{ iconImage }}" alt="Card Icon" class="img-class">
  </div>
  <h2 class="card-title">{{ title }}</h2>
  <p class="card-content">{{ content }}</p>
</div>
